import { useMemo } from "react";
import useGetAccountGroupsV4 from "./useGetAccountGroupsV4";
export default function useMatchPerformanceGroup(accountId, authConfig, groupType) {
    const accountGroups = useGetAccountGroupsV4(authConfig);
    return useMemo(() => {
        if (accountGroups.isLoading || accountGroups.hasError) {
            return accountGroups;
        }
        const accountGroupType = groupType ?? "SINGLE_CLIENT_ACCOUNT";
        const performanceGroup = accountGroups.data.find((ag) => ag.accountGroupType === accountGroupType &&
            ag.virtualAccountIds.some((acctId) => acctId === accountId));
        return {
            data: performanceGroup?.accountGroupId ?? null,
            isLoading: false,
            hasError: false,
        };
    }, [accountId, groupType, accountGroups]);
}
//# sourceMappingURL=useMatchPerformanceGroupV4.js.map